import React, { Component } from 'react';
import { sortBy, prop } from 'ramda'

import { PrintWindow } from 'components'

const tableCellStyles = {
  border: '1px solid #b9b9b9',
  padding: '2px'
};

const tableStyles = {
  pageBreakBefore: 'always',
  width: '100%',
  fontSize: 11,
  textAlign: 'center',
  borderCollapse: 'collapse',
};

export class PlaygroundBase extends Component {
  state = {
    bookings: []
  }

  componentDidMount() {
    const { getAllBookings } = this.props

    console.log("Start")

    // getAllBookings()
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isComplete) {
      const { departureTimestamp } = this.props.bookings.pop()

      // this.props.getAllBookings(departureTimestamp)
    } else {
      if (this.props.bookings.length !== prevProps.bookings.length) {
        console.log(this.props.bookings.length)

        const bookings = this.sortBookings()

        this.setState({ bookings })

        console.log("End")
      }
    }
  }

  sortBookings = () => {
    const { bookings } = this.props

    const withPhone = bookings.filter(({ phone }) => String(phone || '').length > 5)

    const sorted = []

    withPhone.forEach(booking => {
      const exist = sorted.find(({ phone }) => phone == booking.phone)

      if (exist) {
        const existingIndex = sorted.indexOf(exist);
        const prevQty = sorted[existingIndex].qty

        sorted[existingIndex].qty = prevQty + 1
      } else {
        sorted.push({ qty: 1, ...booking })
      }
    })

    const moreThenFiveQty = sorted.filter(({ qty }) => qty > 2)

    return sortBy(prop('qty'))(moreThenFiveQty)
  }

  renderBooking = ({ name, surname, phone, qty }, index) => (
    <tr key={index}>
      <td>
        {name}
      </td>

      <td>
        {surname}
      </td>

      <td>
        {phone}
      </td>

      <td>
        {qty}
      </td>
    </tr>
  )

  render() {
    const { bookings } = this.state

    console.log(bookings.length)

    return !!bookings.length && (
      <PrintWindow>
        <table style={tableStyles}>
          <thead>
            <tr>
              <td>
                Імя
              </td>

              <td>
                Прізвище
              </td>

              <td>
                Телефон
              </td>

              <td>
                к-ть замовлень
              </td>
            </tr>
          </thead>
          <tbody>
            {bookings.map(this.renderBooking)}
          </tbody>
        </table>
      </PrintWindow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Playground/Playground.js